<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="text-align: left;font-size: 21px;font-weight: 500;color: #278ecd;">
      Monthly Sales Report Overall
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <label>Select Month <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <mat-select class="form-control" [(ngModel)]="selected_month_for_report">
          <mat-option *ngFor="let month of month_list_for_last_12_months" [value]=month>
            {{month['month_in_string']}} - {{month['year']}}
          </mat-option>
        </mat-select>
    </div>
    <div class="col-3" style="padding: 20px;">
      <button mat-button class="button-class" style="font-size: 20px;" [disabled]="selected_month_for_report == null"
        (click)="getClicked()">Get</button>
      </div>
  </div>
  </div>
  <!-- <iframe [src]="pdf_data" width="100%" height="800" *ngIf="document_file!== null"></iframe> -->
</section>
